class PasswordValidation {
    constructor(id_pass, id_confirm_pass, form_selector) {
        // Default IDs for password and confirmation fields
        this.id_pass = id_pass || 'password';
        this.id_confirm_pass = id_confirm_pass || 'password_confirmation';
        this.init();
    }

    init() {
        // Password confirmation validation
        $(`#${this.id_pass}, #${this.id_confirm_pass}`).on('keyup blur', () => {
            this.validatePasswordMatch();
        });
    }

    validatePasswordMatch() {
        var password = $(`#${this.id_pass}`).val();
        var confirmPassword = $(`#${this.id_confirm_pass}`).val();
        var errorLabel = $(`#${this.id_confirm_pass}-match-error`);
        var confirmInput = $(`#${this.id_confirm_pass}`);

        // Reset states
        confirmInput.removeClass('is-invalid is-valid');
        
        // Use CSS display property instead of hide/show to preserve text content
        if (errorLabel.length) {
            errorLabel.css('display', 'none');
        }

        if (password || confirmPassword) {
            if (password === confirmPassword) {
                confirmInput.removeClass('is-invalid').addClass('is-valid');
                if (errorLabel.length) {
                    errorLabel.css('display', 'none');
                }
                return true;
            } else {
                confirmInput.addClass('is-invalid').removeClass('is-valid');
                if (errorLabel.length) {
                    errorLabel.css('display', 'block');
                }
                return false;
            }
        } else if (confirmPassword && !password) {
            // Show error if confirmation is filled but password is empty
            confirmInput.addClass('is-invalid').removeClass('is-valid');
            if (errorLabel.length) {
                errorLabel.css('display', 'block');
            }
            return false;
        }

        return true;
    }
}

export { PasswordValidation };